<template>
  <transition
    :css="false"
    @leave="(el, done) => motions['messenger'].leave(done)"
  >
    <div
      v-motion="`messenger`"
      :initial="{ y: 10, opacity: 0 }"
      :enter="{
        y: 0,
        opacity: 1,
        transition: {
          y: {
            duration: 200,
          },
          opacity: {
            duration: 200,
          },
        },
      }"
      :leave="{
        y: 10,
        opacity: 0,
        transition: {
          y: {
            duration: 200,
          },
          opacity: {
            duration: 200,
          },
        },
      }"
      v-if="showContent"
      :class="contentClasses"
      :style="contentStyle"
    >
      <slot />
    </div>
  </transition>
</template>

<script>
import { useMotions } from "@vueuse/motion";

export default {
  name: "PopTransition",
  props: {
    showContent: {
      type: Boolean,
    },
    contentClasses: {
      type: Object,
    },
    contentStyle: {
      type: String,
    },
  },
  setup() {
    const motions = useMotions();

    return {
      motions,
    };
  },
};
</script>

<style scoped></style>
